var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocationArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.931 1.362c.31-.81-.484-1.604-1.293-1.293L.641 5.453c-.906.348-.834 1.653.105 1.9l5.973 1.572a.5.5 0 01.356.356l1.572 5.974c.247.938 1.552 1.01 1.9.104l5.384-13.997zm-.934-.36L9.614 15 8.042 9.027a1.5 1.5 0 00-1.069-1.069L1.001 6.386l13.996-5.384z",
    fill: "#333230"
  })));
}
export default SvgLocationArrow;